import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import style from './styles.scss';

export default function Text({
  className,
  children,
  bold,
  thin,
  meta,
  secondary,
  isError,
  size,
  hoverable,
  inline,
  ml,
  mr,
  mb,
  mt,
  onClick,
  styles,
  width,
}) {
  return (
    <div
      onClick={onClick}
      style={{
        fontSize: size,
        marginRight: mr,
        marginLeft: ml,
        marginTop: mt,
        marginBottom: mb,
        minWidth: width,
        ...styles,
      }}
      className={classNames(
        style.standard,
        className,
        { [style.inline]: inline },
        { [style.hoverable]: hoverable },
        { [style.meta]: meta },
        { [style.bold]: bold },
        { [style.thin]: thin },
        { [style.secondary]: secondary },
        { [style.error]: isError },
        { [style[size]]: size },
      )}
    >
      {children}
    </div>
  );
}
Text.defaultProps = {
  size: 18,
  bold: null,
  meta: null,
  thin: null,
  children: null,
  secondary: null,
  isError: false,
  className: null,
  hoverable: null,
  inline: null,
  ml: 0,
  mr: 0,
  mb: 0,
  mt: 0,
  onClick: () => null,
  width: undefined,
};
Text.propTypes = {
  size: PropTypes.number,
  bold: PropTypes.bool,
  thin: PropTypes.bool,
  meta: PropTypes.bool,
  secondary: PropTypes.bool,
  isError: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  hoverable: PropTypes.bool,
  inline: PropTypes.bool,
  mr: PropTypes.number,
  ml: PropTypes.number,
  mb: PropTypes.number,
  mt: PropTypes.number,
  onClick: PropTypes.func,
  width: PropTypes.number,
};
